import * as React from 'react';
import { AppDesignScheme } from '../../Api';

interface IconFieldProps {
  icon: string;
  value: string | null;
  placeholder?: string;
  editable?: boolean;
  handleChange?: (e: any) => any;
  handleBlur?: () => any;
  AppDesignScheme: AppDesignScheme;
  isDark: boolean;
  dataFd?: string;
  ariaLabel?: string;
}

export class IconField extends React.Component<IconFieldProps, {}> {
  public render(): JSX.Element | null {
    const { AppDesignScheme, isDark, dataFd, ariaLabel } = this.props;

    if (!this.props.value && !this.props.editable) {
      return null;
    }

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      tertiary: {
        color: AppDesignScheme.Tertiary
      }
    };

    return (
      <div className="flex flex-align-center menu__sidepanel__item">
        <i
          className={`tertiary ${this.props.icon}`}
          style={isDark ? styles.primary : styles.tertiary}
          aria-hidden="true"
        />
        {this.props.editable ? (
          <input
            aria-label={ariaLabel}
            className="tertiary clear-margins"
            value={this.props.value || ''}
            onChange={this.props.handleChange}
            onBlur={this.props.handleBlur}
            placeholder={this.props.placeholder || ''}
            style={isDark ? styles.primary : styles.tertiary}
            data-fd={dataFd || ''}
          />
        ) : (
          <p
            className="tertiary clear-margins fd-h4"
            style={isDark ? styles.primary : styles.tertiary}
          >
            {this.props.value}
          </p>
        )}
      </div>
    );
  }
}
